import React from "react";
import t from "i18n";

const CotisationFilterTypeCotisation = ({ activeTabTypeCotisation, onTabTypeCotisationChange }) => {
  return (
    <div style={{ display: "flex", gap: 20 }}>
      <span
        style={{
          cursor: "pointer",
          fontWeight: activeTabTypeCotisation === "cotisation" ? "bold" : "normal",
          borderBottom: activeTabTypeCotisation === "cotisation" ? "3px solid #29394D" : "3px solid #ccc",
          color: activeTabTypeCotisation === "cotisation" ? "#29394D" : "#555",
          paddingBottom: 5,
          width: 165,
          textAlign: "center",
        }}
        onClick={() => onTabTypeCotisationChange("cotisation")}
      >
        {t('Cotisation')}
      </span>
      <span
        style={{
          cursor: "pointer",
          fontWeight: activeTabTypeCotisation === "chiffreAffaire" ? "bold" : "normal",
          borderBottom: activeTabTypeCotisation === "chiffreAffaire" ? "3px solid #29394D" : "3px solid #ccc",
          color: activeTabTypeCotisation === "chiffreAffaire" ? "#29394D" : "#555",
          paddingBottom: 5,
          width: 165,
          textAlign: "center",
        }}
        onClick={() => onTabTypeCotisationChange("chiffreAffaire")}
      >
        {t('CA')}
      </span>
    </div>
  );
};

export default CotisationFilterTypeCotisation;



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/CotisationFilterTypeCotisation.js